import WebsiteBehaviors from "../website-behaviors/index.js";

class Medium extends WebsiteBehaviors {
	identifier() {
		return "Medium";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "medium.com");
	}

	styles() {
		// language=CSS
		return `
			.highlightMenu,
			.popover {
				display: none !important;
			}
			.markup--quote {
				cursor: text !important;
			}
		`;
	}
}

export default Medium;
